import { toDocId, toRefValue } from "./ids";
import { DEFAULT_LABEL_COLOR } from "../constants/labelColors";

/**
 * Pure builder for a label document, matching Android's LabelData wire format
 * so doc.toObject(LabelData) deserializes cleanly. `labelId` is numeric Int32
 * (doc path = String(labelId)); `projectId` is a number (scoped) or null
 * (global). Returns null for an empty name.
 */
export function buildLabel(id, name, color, projectId, now) {
  const trimmed = (name || "").trim();
  if (!trimmed) return null;
  return {
    labelId: id,
    name: trimmed,
    color: color || DEFAULT_LABEL_COLOR,
    projectId: projectId == null ? null : toRefValue(projectId),
    defaultActionTemplateId: null,
    remoteState: "remote_state_synced",
    firestoreId: toDocId(id),
    updatedAt: now,
  };
}
